import React, { useState } from 'react'
import styled from 'styled-components'
import { Container, Kicker, MOBILE } from '../CustomLanding.styled'
import { colors, faq } from '../content'

const FaqSection: React.FC = () => {
	/* Matches the design behaviour: the first question starts open,
	   clicking an open question closes it. */
	const [open, setOpen] = useState(0)

	return (
		<Section id="faq">
			<Container>
				<Kicker>{faq.kicker}</Kicker>
				<Title>{faq.title}</Title>
				<List>
					{faq.items.map((item, index) => (
						<Item key={item.q} onClick={() => setOpen(open === index ? -1 : index)}>
							<QuestionRow>
								<Question>{item.q}</Question>
								<Toggle open={open === index}>+</Toggle>
							</QuestionRow>
							{open === index && <Answer>{item.a}</Answer>}
						</Item>
					))}
				</List>
			</Container>
		</Section>
	)
}

export default FaqSection

const Section = styled.section`
	background: #ffffff;
	padding: 36px 0 40px;
	border-top: 1px solid rgba(22, 58, 132, 0.1);
	${MOBILE} {
		padding: 32px 0 36px;
	}
`

const Title = styled.h2`
	font-weight: 700;
	font-size: clamp(24px, 2.2vw, 34px);
	line-height: 1.35;
	color: ${colors.navy};
	margin: 0 0 14px;
	${MOBILE} {
		font-size: 26px;
		line-height: 1.4;
		margin-bottom: 16px;
	}
`

const List = styled.div`
	border-top: 1px solid ${colors.line};
	display: grid;
	grid-template-columns: 1fr 1fr;
	column-gap: 56px;
	align-items: stretch;
	${MOBILE} {
		display: block;
	}
`

const Item = styled.div`
	border-bottom: 1px solid ${colors.line};
	cursor: pointer;
`

const QuestionRow = styled.div`
	display: flex;
	align-items: center;
	gap: 20px;
	padding: 17px 0;
	${MOBILE} {
		gap: 14px;
		padding: 20px 0;
	}
`

const Question = styled.div`
	font-weight: 700;
	font-size: 17px;
	color: ${colors.navy};
	flex: 1;
	${MOBILE} {
		font-size: 18px;
		line-height: 1.5;
	}
`

const Toggle = styled.div<{ open: boolean }>`
	width: 30px;
	height: 30px;
	flex: 0 0 auto;
	border-radius: 999px;
	border: 1px solid rgba(22, 58, 132, 0.2);
	display: flex;
	align-items: center;
	justify-content: center;
	color: ${colors.blue};
	font-size: 17px;
	line-height: 1;
	transition: transform 0.2s ease;
	transform: ${p => (p.open ? 'rotate(135deg)' : 'rotate(0deg)')};
	${MOBILE} {
		width: 28px;
		height: 28px;
		font-size: 17px;
	}
`

const Answer = styled.p`
	margin: 0;
	padding: 0 0 28px;
	font-size: 17px;
	line-height: 1.95;
	color: ${colors.muted};
	max-width: 640px;
	${MOBILE} {
		padding-bottom: 22px;
		font-size: 15px;
		line-height: 1.9;
		max-width: none;
	}
`
